<mat-dialog-content>
  <h1>Temporary Issue</h1>
  @if (toCreate) {
    <div>
      <p>Handoff type is temporarily unavailable until turned back on</p>
      <mat-radio-group
        aria-labelledby="example-radio-group-label"
        class="example-radio-group"
        [(ngModel)]="duration"
        required>
        <mat-radio-button class="example-radio-button" value="1">Tomorrow</mat-radio-button>
        <mat-radio-button class="example-radio-button" value="2">in 2 Days</mat-radio-button>
      </mat-radio-group>
    </div>
  }

  @if (!toCreate) {
    <p>Are you sure you want to make this Handoff Type available again?</p>
  }

  <div class="button-container">
    <button mat-flat-button (click)="onNoClick()">Cancel</button>
    <button mat-flat-button color="accent" (click)="saveAction()">Apply</button>
  </div>
</mat-dialog-content>
